import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface DeleteVendorProductResponse extends Response {
	data: Record<string, unknown>
}

export const deleteVendorProduct = async (
	productNo: string,
): Promise<DeleteVendorProductResponse> => {
	const response = await client.delete<DeleteVendorProductResponse>(
		`/vendors/products/${productNo}`,
		{},
	)

	return response.data
}
